import { render } from "./TradeDetail.vue?vue&type=template&id=a71ee27c"
import script from "./TradeDetail.vue?vue&type=script&lang=js"
export * from "./TradeDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\LuisFolder\\project\\evcharge-ev-server-rocketmq\\evcharge-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__